export default __webpack_public_path__ + "static/media/bg-desktop1-dark.c4f21244.svg";